var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.88 40.88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.022 14.27a3.073 3.073 0 0 0-2.161-2.162c-1.92-.525-9.597-.525-9.597-.525s-7.677 0-9.6.505a3.134 3.134 0 0 0-2.159 2.182A32.38 32.38 0 0 0 8 20.17a32.26 32.26 0 0 0 .505 5.9 3.076 3.076 0 0 0 2.162 2.162c1.939.525 9.6.525 9.6.525s7.677 0 9.6-.505a3.076 3.076 0 0 0 2.162-2.162 32.38 32.38 0 0 0 .505-5.9 30.768 30.768 0 0 0-.512-5.92zm0 0",
    fill: "var(--iconColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.819 23.645 6.384-3.677-6.384-3.677zm0 0",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.441 1.699c10.35.001 18.74 8.392 18.739 18.742s-8.392 18.74-18.742 18.74S1.698 30.79 1.698 20.44C1.71 10.094 10.095 1.71 20.441 1.699m0-1.7A20.44 20.44 0 0 0 5.986 34.892 20.44 20.44 0 0 0 40.88 20.439C40.88 9.151 31.729 0 20.441-.001z",
    fill: "var(--iconColor)"
  })));
};
export default SvgYoutube;